<script>
    // core components
    import { Route, Router } from "svelte-routing";
    import JurisdictionTable from "../../components/Cards/Jurisdiction/JurisdictionTable.svelte";
    import JurisdictionForm from "../../components/Forms/Jurisdiction/JurisdictionForm.svelte";
    export let location;
</script>

<Router url="jurisdiction">
    <Route component="{JurisdictionTable}" />
    <Route path="table" component="{JurisdictionTable}" />
    <Route path="create" component="{JurisdictionForm}" />
    <Route path="edit" component="{JurisdictionForm}" />
</Router>
